import i18n from './i18n/i18n'
import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App.vue'
import router from './router'
import store from './store'
import './components/http.js'
import './components/filters.js'
import './components/functions.js'

import Badge from 'vux/src/components/badge/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import Group from 'vux/src/components/group/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'


Vue.use(ToastPlugin, {position: 'middle'})
Vue.component(Loading.name, Loading)
Vue.component(Spinner.name, Spinner)
Vue.component(XInput.name, XInput)
Vue.component(Card.name, Card)
Vue.component(Group.name, Group)
Vue.component(XButton.name, XButton)
Vue.component(Cell.name, Cell)
Vue.component(Badge.name, Badge)
Vue.component(Toast.name, Toast)
Vue.component(XHeader.name, XHeader)
Vue.component(Flow.name, Flow)
Vue.component(FlowState.name, FlowState)
Vue.component(FlowLine.name, FlowLine)
Vue.component(Datetime.name, Datetime)
Vue.component(PopupPicker.name, PopupPicker)
Vue.component(Search.name, Search)
Vue.component(PopupRadio.name, PopupRadio)
Vue.component(Selector.name, Selector)
Vue.component(Step.name, Step)
Vue.component(StepItem.name, StepItem)
Vue.component(Checklist.name, Checklist)
Vue.component(Flexbox.name, Flexbox)
Vue.component(FlexboxItem.name, FlexboxItem)
Vue.component(XTextarea.name, XTextarea)
Vue.component(CellFormPreview.name, CellFormPreview)
Vue.component(XTable.name, XTable)
Vue.component(LoadMore.name, LoadMore)
Vue.component(Divider.name, Divider)
Vue.component(XDialog.name, XDialog)
Vue.component(XImg.name, XImg)
Vue.component(Checker.name, Checker)
Vue.component(CheckerItem.name, CheckerItem)
Vue.component(Confirm.name, Confirm)
Vue.component(Icon.name, Icon)
Vue.component(CheckIcon.name, CheckIcon)

Vue.directive('TransferDom', TransferDom)

FastClick.attach(document.body)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
i18n,
components: {App},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js